// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--light_text_color:#666}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px;box-sizing:content-box}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px;margin-right:auto;margin-left:auto}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
